import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Callout, Card, CardHeader, Typography } from '@otp/ui';

import { User } from 'src/graphql/generated/graphql';

import styles from './index.module.css';
import { ContentWrapper } from '../wrapper/content/wrapper';
import { Lock } from '@otp/icons';
import clsx from 'clsx';
import { Routes } from '../router/constants';
import { Link, useNavigate } from 'react-router-dom';
import { useDeviceContext } from 'src/context/device.context';

interface UnauthorizedProps {
  user?: User;
}

export const Unauthorized = (props: UnauthorizedProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useDeviceContext();

  return (
    <Card
      noBorder
      className={clsx(
        styles.wrapper,
        {
          'm-auto': !isMobile,
          'h-full': isMobile,
          'w-full': isMobile,
          'w-1/2': !isMobile,
        },
        'justify-center',
        'max-w-max'
      )}
      {...props}
    >
      <Callout variant="outlined" severity="error">
        {t('common.unauthorized')}
      </Callout>
      <Lock className="m-auto mt-2" />
      <Typography variant="h6">{t('common.unauthorized-title')}</Typography>
      <Typography variant="subtitle1">
        {t('common.unauthorized-description')}
      </Typography>
      <div className="flex mt-2">
        <Button
          className="ml-auto"
          variant="outlined"
          onClick={() => navigate(0)}
        >
          {t('common.refresh')}
        </Button>
        <Link to={Routes.home.path} className="ml-2">
          <Button variant="contained">{t('common.back-to-home')}</Button>
        </Link>
      </div>
    </Card>
  );
};

export const UnauthorizedPage = (props: UnauthorizedProps) => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <Unauthorized {...props} />
    </ContentWrapper>
  );
};

export default Unauthorized;
